<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new bond tracking</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Customer name:</label>
                  <span style="font-size:13px;">{{Requisition.customer_name}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Cargo no:</label>
                  <span style="font-size:13px;">{{Requisition.container_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">T812 entry:</label>
                  <span style="font-size:13px;">{{Requisition.t812_entry}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Truck no:</label>
                  <span style="font-size:13px;">{{Requisition.truck_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Trailer no:</label>
                  <span style="font-size:13px;">{{Requisition.trailer_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Driver name:</label>
                  <span style="font-size:13px;">{{Requisition.driver_name}}</span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <p></p>
        <p></p>

        <form @submit.prevent="newTrucktracking()">
          <div class="row">
            <input type="hidden" class="requisition_id" :value="Requisition.id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Tracking date</label>
                <input
                  type="date"
                  class="form-control tracking_date input-rounded f-s-14"
                  placeholder="tracking date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="checkbox" class="email" id="defaultUnchecked" @click="show = !show">
          
                <!-- <select name="email" class="form-control email" @click="show = !show" value="true">
                  <option disabled value>Sending</option>
                  <option value="false">NO</option>
                  <option>YES</option>
                </select> -->
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Truck location</label>
                <input
                  type="text"
                  class="form-control truck_location input-rounded f-s-14"
                  placeholder="truck location"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row" v-if="show">
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control email_address input-rounded f-s-14"
                  placeholder="To"
                  :value="Requisition.email_address"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control email_subject input-rounded f-s-14"
                  placeholder="Subject"
                  :value="'TRUCK TRACKING FOR ' + '' + '---' + 'TRUCK: ' +  Requisition.truck_no + '---' +'TRAILER: ' + Requisition.trailer_no + '----' + 'for container: ' + Requisition.container_no"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <textarea
                  name="name"
                  rows="8"
                  cols="80"
                  class="form-control email_message input-rounded f-s-14"
                  style="height:300px"
                ></textarea>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTrucktracking btn-rounded">
            <i class="fa fa-plus"></i> Add tracking
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingTrucktrackingLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  data() {
    return { show: false };
  },
  created() {
    if (this.$store.getters.Requisition.length === 0) {
      router.push("/managerequisitions");
    }
  },

  computed: {
    ...mapGetters(["Requisition"])
  },

  methods: {
    ...mapActions(["newTrucktracking"])
  }
};
</script>
<style scoped>
.creatingTrucktrackingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucktrackings/trucktracking.vue